export const Bio = {
  name: "Urvansh Shah",
  roles: [
    "Analyst", "Software Developer Engineer and Senior Data Science Analyst"
  ],
  description:
    "Senior Data Science Analyst and Software Development Engineer with 4+ years of experience and a Master's in Data Science from Arizona State University. I build scalable, data-driven solutions using Python, machine learning, and cloud technologies, turning complex problems into measurable business impact.",
  availableForOpportunities: true,
  github: "https://github.com/urvanshshah",
  resume: "/Urvansh_Shah_Resume.pdf",
  linkedin: "https://www.linkedin.com/in/urvansh-shah",
  insta: "https://www.instagram.com/urvanshshah",
  medium: "https://medium.com/@urvanshshah",
  googleScholar: "https://scholar.google.com/citations?user=CFQMGOsAAAAJ&hl=en",
  email: "mailto:urvanshshah9@gmail.com",
  whatsapp: "https://wa.me/16026571344",
  phone: "+1-602-657-1344"
};

export const skills = [
  {
    title: "Programming Languages",
    skills: [
      {
        name: "Python",
        image: "/icons/skills/python.svg",
      },
      {
        name: "R",
        image: "/icons/skills/r.svg",
      },
      {
        name: "SQL",
        image:
          "https://www.svgrepo.com/show/331760/sql-database-generic.svg",
      },
      {
        name: "JavaScript",
        image: "/icons/skills/javascript.svg",
      },
      {
        name: "Java",
        image: "/icons/skills/java.svg",
      },
      {
        name: "C",
        image: "/icons/skills/c.svg",
      },
      {
        name: "C++",
        image: "/icons/skills/cplusplus.svg",
      },
      {
        name: "TypeScript",
        image: "/icons/skills/typescript.svg",
      },
      {
        name: "Bash/Shell",
        image: "/icons/skills/bash.svg",
      },
      {
        name: "Scala",
        image: "/icons/skills/scala.svg",
      },
      {
        name: "Kotlin",
        image: "/icons/skills/kotlin.svg",
      },
    ],
  },
  {
    title: "Database Management",
    skills: [
      {
        name: "MySQL",
        image: "/icons/skills/mysql.svg",
      },
      {
        name: "PostgreSQL",
        image: "/icons/skills/postgresql.svg",
      },
      {
        name: "MongoDB",
        image: "/icons/skills/mongodb.svg",
      },
      {
        name: "Snowflake",
        image: "/icons/skills/snowflake.svg",
      },
      {
        name: "Amazon Redshift",
        image: "/icons/skills/redshift.svg",
      },
      {
        name: "Redis",
        image: "/icons/skills/redis.svg",
      },
      {
        name: "Elasticsearch",
        image: "/icons/skills/elasticsearch.svg",
      },
      {
        name: "Apache Cassandra",
        image: "/icons/skills/cassandra.svg",
      },
      {
        name: "BigQuery",
        image: "/icons/skills/bigquery.svg",
      },
      {
        name: "Neo4j",
        image: "/icons/skills/neo4j.svg",
      },
      {
        name: "Data Mining",
        image: "https://cdn-icons-png.flaticon.com/512/5139/5139742.png",
      }
    ]
  },
  {
    title: "Cloud & DevOps",
    skills: [
      {
        name: "Amazon Web Services",
        image: "/icons/skills/aws.svg",
      },
      {
        name: "Microsoft Azure",
        image: "https://swimburger.net/media/ppnn3pcl/azure.png",
      },
      {
        name: "Docker",
        image: "/icons/skills/docker.svg",
      },
      {
        name: "Kubernetes",
        image: "/icons/skills/kubernetes.svg",
      },
      {
        name: "Apache Airflow",
        image: "/icons/skills/airflow.svg",
      },
      {
        name: "MLflow",
        image:
          "https://www.vectorlogo.zone/logos/mlflow/mlflow-icon.svg",
      },
      {
        name: "Git",
        image: "/icons/skills/git.svg",
      },
      {
        name: "GitHub",
        image: "https://cdn-icons-png.flaticon.com/512/25/25231.png",
      },
      {
        name: "Jira",
        image:
          "https://cledara-public.s3.eu-west-2.amazonaws.com/Jira-software.png",
      },
      {
        name: "Terraform",
        image: "/icons/skills/terraform.svg",
      },
      {
        name: "Jenkins",
        image: "/icons/skills/jenkins.svg",
      },
      {
        name: "GitHub Actions",
        image:
          "https://avatars.githubusercontent.com/u/44036562?s=200&v=4",
      },
      {
        name: "Prometheus",
        image:
          "https://www.vectorlogo.zone/logos/prometheusio/prometheusio-icon.svg",
      },
      {
        name: "Grafana",
        image:
          "https://www.vectorlogo.zone/logos/grafana/grafana-icon.svg",
      },
      {
        name: "Firebase",
        image: "/icons/skills/firebase.svg",
      },
    ],
  },

  {
    title: "Web Technologies",
    skills: [
      {
        name: "React.js",
        image: "/icons/skills/react.svg",
      },
      {
        name: "Node.js",
        image: "/icons/skills/nodejs.svg",
      },
      {
        name: "FastAPI",
        image: "/icons/skills/fastapi.svg",
      },
      {
        name: "Flask",
        image: "/icons/skills/flask.svg",
      },
      {
        name: "REST API",
        image:
          "https://cdn-icons-png.flaticon.com/512/2164/2164832.png",
      },
      {
        name: "HTML",
        image: "/icons/skills/html.svg",
      },
      {
        name: "CSS",
        image: "/icons/skills/css.svg",
      },
      {
        name: "WordPress Development",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/wordpress/wordpress-plain.svg",
      },
      {
        name: "Next.js",
        image: "/icons/skills/nextjs.svg",
      },
      {
        name: "Express.js",
        image: "/icons/skills/express.svg",
      },
      {
        name: "GraphQL",
        image: "/icons/skills/graphql.svg",
      },
      {
        name: "Redux",
        image: "/icons/skills/redux.svg",
      },
      {
        name: "Tailwind CSS",
        image: "/icons/skills/tailwindcss.svg",
      },
      {
        name: "Bootstrap",
        image: "/icons/skills/bootstrap.svg",
      },
    ],
  },



  {
    title: "Data Visualization & BI",
    skills: [
      {
        name: "Power BI",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/c/cf/New_Power_BI_Logo.svg",
      },
      {
        name: "Tableau",
        image:
          "https://cdn.worldvectorlogo.com/logos/tableau-software.svg",
      },
      {
        name: "Matplotlib",
        image: "/icons/skills/matplotlib.svg",
      },
      {
        name: "Seaborn",
        image:
          "https://seeklogo.com/images/S/seaborn-logo-244EB2DEC5-seeklogo.com.png",
      },
      {
        name: "Excel",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Microsoft_Excel_2013-2019_logo.svg/1200px-Microsoft_Excel_2013-2019_logo.svg.png",
      },
    ],
  },




  {
    title: "Data Engineering & Big Data",
    skills: [
      {
        name: "Apache Spark",
        image: "/icons/skills/spark.svg",
      },
      {
        name: "Apache Kafka",
        image: "/icons/skills/kafka.svg",
      },
      {
        name: "dbt",
        image:
          "https://seeklogo.com/images/D/dbt-logo-500AB0BAA7-seeklogo.com.png",
      },
      {
        name: "ETL",
        image:
          "https://cdn-icons-png.flaticon.com/512/2103/2103658.png",
      },
      {
        name: "Python Automation",
        image:
          "https://png.pngtree.com/png-vector/20230330/ourmid/pngtree-automation-line-icon-vector-png-image_6675340.png",
      },
      {
        name: "Scrapy",
        image:
          "https://assets.streamlinehq.com/image/private/w_300,h_300,ar_1/f_auto/v1/icons/logos/scrapy-85b3r6nhyk2pr81rj15lbf.png/scrapy-r5fwm7gr3smdzpcw8rlx.png?_a=DAJFJtWIZAAC",
      },
      {
        name: "Apache Hadoop",
        image: "/icons/skills/hadoop.svg",
      },
      {
        name: "Apache Hive",
        image: "/icons/skills/hive.svg",
      },
      {
        name: "Apache Flink",
        image:
          "https://www.vectorlogo.zone/logos/apache_flink/apache_flink-icon.svg",
      },
      {
        name: "Databricks",
        image: "/icons/skills/databricks.svg",
      },
      {
        name: "Delta Lake",
        image: "/icons/skills/deltalake.svg",
      },
    ],
  },



  {
    title: "Data Science & Machine Learning",
    skills: [
      {
        name: "TensorFlow",
        image: "/icons/skills/tensorflow.svg",
      },
      {
        name: "PyTorch",
        image: "/icons/skills/pytorch.svg",
      },
      {
        name: "Scikit-learn",
        image: "/icons/skills/scikitlearn.svg",
      },
      {
        name: "XGBoost",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/6/69/XGBoost_logo.png",
      },
      {
        name: "Machine Learning",
        image:
          "https://png.pngtree.com/png-vector/20230407/ourmid/pngtree-deep-learning-line-icon-vector-png-image_6688986.png",
      },
      {
        name: "NLP",
        image:
          "https://cdn-icons-png.flaticon.com/512/2103/2103633.png",
      },
      {
        name: "Pandas",
        image: "/icons/skills/pandas.svg",
      },
      {
        name: "NumPy",
        image: "/icons/skills/numpy.svg",
      },
      {
        name: "SciPy",
        image: "https://cdn.icon-icons.com/icons2/3914/PNG/512/scipy_logo_icon_248581.png",
      },
      {
        name: "Jupyter Notebooks",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/3/38/Jupyter_logo.svg",
      },
      {
        name: "Google Colab",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Google_Colaboratory_SVG_Logo.svg/1200px-Google_Colaboratory_SVG_Logo.svg.png",
      },
      {
        name: "Keras",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/a/ae/Keras_logo.svg",
      },
      {
        name: "Hugging Face",
        image:
          "https://huggingface.co/front/assets/huggingface_logo.svg",
      },
      {
        name: "OpenCV",
        image:
          "https://www.vectorlogo.zone/logos/opencv/opencv-icon.svg",
      },
      {
        name: "LangChain",
        image:
          "https://avatars.githubusercontent.com/u/126733545?s=200&v=4",
      },
      {
        name: "NLTK",
        image:
          "https://miro.medium.com/v2/resize:fit:592/1*YM2HXc7f4v02pZBEO8h-qw.png",
      },
      {
        name: "Statsmodels",
        image:
          "https://www.statsmodels.org/stable/_images/statsmodels-logo-v2-horizontal.svg",
      },
    ],
  },

  {
    title: "Development Tools & IDEs",
    skills: [
      {
        name: "Visual Studio Code",
        image:
          "https://www.cdnlogo.com/logos/v/82/visual-studio-code.svg",
      },
      {
        name: "PyCharm",
        image:
          "https://icon.icepanel.io/Technology/svg/PyCharm.svg",
      },
      {
        name: "Selenium Automation",
        image:
          "https://img.icons8.com/?size=512&id=38553&format=png",
      },
      {
        name: "Object-Oriented Programming",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/OOP.svg/1280px-OOP.svg.png",
      },
      {
        name: "Data Structures & Algorithms",
        image:
          "https://static.thenounproject.com/png/1430829-200.png",
      },
      {
        name: "Agile/Scrum",
        image: "/icons/skills/scrum.svg",
      },
    ],
  },

  {
    title: "Soft Skills",
    skills: [
      {
        name: "Leadership",
        image:
          "https://cdn-icons-png.flaticon.com/512/1705/1705312.png",
      },
      {
        name: "Management",
        image: "https://cdn-icons-png.flaticon.com/512/3588/3588592.png",
      },
      {
        name: "Teaching",
        image:
          "https://cdn-icons-png.flaticon.com/512/3976/3976625.png",
      },
      {
        name: "Public Relations",
        image:
          "https://cdn-icons-png.flaticon.com/512/5360/5360641.png",
      },
      {
        name: "Digital Marketing",
        image:
          "https://www.freeiconspng.com/thumbs/marketing-png/content-marketing-6.png",
      },
      {
        name: "Research",
        image:
          "https://png.pngtree.com/png-vector/20230412/ourmid/pngtree-research-line-icon-vector-png-image_6703508.png",
      },
    ],
  },

  {
    title: "AI/ML Tools",
    skills: [
      {
        name: "OpenAI API",
        image:
          "https://static.vecteezy.com/system/resources/previews/022/227/364/non_2x/openai-chatgpt-logo-icon-free-png.png",
      },
      {
        name: "Anthropic Claude",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBJzQ-1706SLwx8kJLqOGz8RyAcSXJe4Qm_A&s",
      },
      {
        name: "Stable Diffusion",
        image:
          "https://avatars.githubusercontent.com/u/110832366?s=280&v=4",
      },
      {
        name: "LLaMA",
        image:
          "https://cdn-icons-png.flaticon.com/512/10054/10054652.png",
      },
      {
        name: "A/B Testing",
        image:
          "https://cdn-icons-png.flaticon.com/512/2920/2920277.png",
      },
      {
        name: "MLOps",
        image:
          "https://cdn-icons-png.flaticon.com/512/9850/9850835.png",
      },
      {
        name: "LangGraph",
        image: "/icons/skills/langgraph.svg",
      },
      {
        name: "Vector Databases",
        image: "/icons/skills/vectordb.svg",
      },
      {
        name: "RAG",
        image: "/icons/skills/rag.svg",
      },
      {
        name: "LLM Evaluation",
        image: "/icons/skills/llmeval.svg",
      },
      {
        name: "Generative AI",
        image: "/icons/skills/genai.svg",
      },
    ],
  },

  {
    title: "Testing & Quality Assurance",
    skills: [
      {
        name: "Jest",
        image:
          "https://www.vectorlogo.zone/logos/jestjsio/jestjsio-icon.svg",
      },
      {
        name: "Pytest",
        image:
          "https://docs.pytest.org/en/stable/_static/pytest_logo_curves.svg",
      },
      {
        name: "Unit Testing",
        image:
          "https://cdn-icons-png.flaticon.com/512/4149/4149679.png",
      },
      {
        name: "Integration Testing",
        image:
          "https://cdn-icons-png.flaticon.com/512/2920/2920349.png",
      },
      {
        name: "GitLab",
        image:
          "https://www.vectorlogo.zone/logos/gitlab/gitlab-icon.svg",
      },
      {
        name: "Bitbucket",
        image:
          "https://www.vectorlogo.zone/logos/bitbucket/bitbucket-icon.svg",
      },
    ],
  },

  {
    title: "Advanced ML Techniques",
    skills: [
      {
        name: "Deep Learning",
        image:
          "https://cdn-icons-png.flaticon.com/512/8637/8637099.png",
      },
      {
        name: "Computer Vision",
        image:
          "https://cdn-icons-png.flaticon.com/512/2103/2103665.png",
      },
      {
        name: "Reinforcement Learning",
        image:
          "https://cdn-icons-png.flaticon.com/512/4341/4341139.png",
      },
      {
        name: "Time Series Analysis",
        image:
          "https://cdn-icons-png.flaticon.com/512/2920/2920235.png",
      },
      {
        name: "Feature Engineering",
        image:
          "https://cdn-icons-png.flaticon.com/512/3588/3588435.png",
      },
      {
        name: "Model Deployment",
        image:
          "https://cdn-icons-png.flaticon.com/512/2920/2920277.png",
      },
    ],
  },

];

export const experiences = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ9QlNlEqxdd1bF71qHC3c7YE7fB41gS7Pl6rlPEhc4ZrVGcssHsYm181xZVFonJ2atwv8&usqp=CAU",
    role: "Research Assistant Technical Staff",
    company: "Arizona State University (SciHub)",
    date: "Nov 2025 - Present",
    desc: "",
    accomplishments: [
      "Architected a Python data pipeline for ingestion, validation, and feature engineering on empirical spectral and sensor datasets, applying statistical & regression modeling techniques to drive research analytical outcomes, improving throughput by 71%.",
      "Deployed a supervised model via Scikit-learn to translate empirical calibration data into optimized configurations, replacing manual trial & error tuning and reducing iteration cycle time by 54% while improving predictive accuracy by 63%.",
      "Designed a closed-loop embedded control system on ESP32-S3, implementing real-time DMX512 protocol and analog signal conditioning (TL074 op-amp) across a multi-channel sensor/actuator array, enabling hardware-in-the-loop validation.",
      "Embedded directly with domain-expert researchers, translating ambiguous and evolving requirements into rapidly prototyped full-stack software and hardware solutions, shipping 7+ field-ready systems from concept to deployment.",
      "Led cross-functional integration across an 8+ person software/hardware team, delivering a full data-to-hardware pipeline end-to-end from MVP to production-ready deployment and supporting 11+ downstream research and exhibition use cases."
    ],
    skills: [
      "Data Science",
      "Software Development",
      "Research & Development",
      "System Design",
      "Experimentation",
      "Python",
      "Machine Learning",
      "ESP32-S3",
      "Scikit-learn",
      "DMX512",
      "Academic Research"
    ],
  },
  {
    id: 1,
    img: "https://media.licdn.com/dms/image/v2/C4D0BAQF7zqbzbyb9pQ/company-logo_200_200/company-logo_200_200/0/1639412633827/sila_nanotechnologies_inc__logo?e=2147483647&v=beta&t=_7iqGhnZ5pZEQL7jabD2eWOpAZyGxRqIPkdoUd_adQs",
    role: "Data Science Intern",
    company: "Sila Nanotechnologies",
    date: "Jun 2025 - Nov 2025",
    desc: "",
    accomplishments: [
      "Implemented and optimized ETL pipelines processing 500K+ sensor and simulation records weekly using Snowflake, Python, and Airflow, accelerating lithium-ion cell research throughput by 35% and reducing manual processing time by 60%.",
      "Programmed a modular full-stack GUI for PyBaMM simulations via FastAPI, SQLite, and JavaScript, enabling interactive configuration of physics-based models and real-time visualization, supporting 10+ simulations across 3+ R&D teams.",
      "Applied machine learning models (regression, classification) via Scikit-learn and Pandas to predict battery material performance and degradation patterns, achieving 15% higher model precision through feature selection and optimization.",
      "Automated data ingestion and transformation workflows with Airflow DAGs for battery simulation and experimental datasets, ensuring reliable data delivery pipelines and shortening experimentation cycles by 25% for digital twin model development.",
      "Collaborated with senior scientists to design data-driven experiments for lithium-ion battery optimization, integrating simulation outputs into performance dashboards and supporting 5+ workflows for electrode configuration research."
    ],
    skills: [
      "Snowflake",
      "Python",
      "Airflow",
      "FastAPI",
      "SQLite",
      "JavaScript",
      "Scikit-learn",
      "Pandas",
      "Machine Learning",
      "ETL",
      "Data Science",
      "Battery Technology",
      "Data Analysis",
      "Materials Science",
      "Research & Development"
    ],
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ9QlNlEqxdd1bF71qHC3c7YE7fB41gS7Pl6rlPEhc4ZrVGcssHsYm181xZVFonJ2atwv8&usqp=CAU",
    role: "Graduate Teaching Assistant",
    company: "Arizona State University (EEE)",
    date: "Aug 2024 - May 2025",
    desc: "",
    accomplishments: [
      "Facilitated lab instruction and technical mentorship for 280+ students across software engineering and data science coursework, clarifying core concepts in programming, algorithms, and applied data analysis to strengthen practical proficiency.",
      "Designed and applied structured grading rubrics as Lead Lab Grader to evaluate 98+ code submissions and lab assignments per term, ensuring standards-based, consistent assessment and improving average student lab performance by 37%."
    ],
    skills: [
      "Mathematical and Logical Reasoning",
      "Programming and Simulation Tools",
      "Problem-Solving",
      "Data Representation",
      "Algorithmic Thinking",
      "Technical Mentorship",
      "Curriculum Design"
    ],
  },
  {
    id: 3,
    img: "/dentsu-logo.png",
    role: "Senior Analyst",
    company: "Dentsu",
    date: "Jun 2022 - Jul 2024",
    desc: "",
    accomplishments: [
      "Devised and launched scalable AI/ML models via TensorFlow, PyTorch, and Scikit-learn, optimizing NLP workflows for large-scale data processing on AWS (Lambda, S3, Redshift, SageMaker), improving prediction accuracy by 55%.",
      "Operationalized Python automation with AI-driven forecasting models, reducing time from 6 hours to 34 seconds, elevating operations with checklists, and collaborating with USA clients to refine functionality, driving a 500% revenue increase.",
      "Fabricated large-scale ETL and real-time analytics pipelines using Apache Spark, SQL, and Airflow, automating feature engineering and model training workflows, increasing data ingestion speed by 40%, accelerating business decisions.",
      "Designed and implemented an end-to-end CI/CD MLOps pipeline via MLflow, Docker, Airflow, and Kubernetes, enabling automated model versioning, cloud-based deployment, and monitoring, reducing deployment time by 45%.",
      "Created interactive dashboards and balanced reporting systems using Power BI, Tableau, and SQL, integrating real-time KPIs and predictive analytics to drive data-driven decision-making, reducing manual reporting efforts by 50%."
    ],
    skills: [
      "TensorFlow",
      "PyTorch",
      "Scikit-learn",
      "AWS",
      "Python",
      "Apache Spark",
      "SQL",
      "Airflow",
      "MLflow",
      "Docker",
      "Kubernetes",
      "Power BI",
      "Tableau"
    ],
  },

  {
    id: 4,
    img: "https://s3.amazonaws.com/spoonflower/public/design_thumbnails/0961/5825/9615825_rrpeonies-_cream-w-shadow_sm-flowers_denim-background_reduced-gold-lattuce_-repeat-pattern_shop_thumb.png",
    role: "Co-Founder",
    company: "Mahaveer Technologies",
    date: "Jan 2022 - May 2022",
    desc: "",
    accomplishments: [
      "Architected a cloud data warehouse on Snowflake & Redshift, automating ETL with Spark, elevating performance by 50%.",
      "Formulated and pioneered data governance framework using dbt & Great Expectations, guaranteeing 99.8% data accuracy.",
      "Integrated a fraud detection system via Neo4j & XGBoost, reducing 42% financial risks and fraudulent cases.",
      "Constructed A/B testing pipelines with Bayesian optimization, refining marketing strategies and increasing CTR by 23%.",
      "Orchestrated real-time streaming analytics dashboards with Kafka & BigQuery, boosting data visibility by 57%."
    ],
    skills: [
      "Snowflake",
      "Redshift",
      "ETL",
      "Spark",
      "dbt",
      "Great Expectations",
      "Neo4j",
      "XGBoost",
      "Bayesian Optimization",
      "Kafka",
      "BigQuery"
    ],
  },

  {
    id: 5,
    img: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg",
    role: "Software Developer Intern",
    company: "Microsoft",
    date: "Oct 2021 - Dec 2021",
    desc: "",
    accomplishments: [
      "Built RESTful APIs with FastAPI & Azure Functions, streamlining AI inference and reducing response latency by 35%.",
      "Conducted metadata analysis on 10,000+ websites using Azure and Synapse, evaluating system scalability and robustness."
    ],
    skills: [
      "FastAPI",
      "Azure Functions",
      "Azure",
      "Synapse",
      "API Development",
      "Web Development"
    ],
  },
  {
    id: 6,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-UmD8ZPZAub0KBH_962OtVZl38dBMg4_7VQ&s",
    role: "Assistant Professor",
    company: "Nipesh Private Tutorials",
    date: "Sep 2018 - Oct 2021",
    desc: "",
    accomplishments: [
      "Teaching Assistant: Part-time Assistant Professor, enhancing students’ overall academic performance by 32%.",
      "Created customized materials to boost student engagement and comprehension, increasing satisfaction by 67%."
    ],
    skills: [
      "Teaching",
      "Curriculum Development",
      "Student Engagement"
    ],
  },
  {
    id: 7,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQIPfQ04XEBn1m1r3Ig1aVQ6TG63IIeds2U3g&s",
    role: "Data Scientist",
    company: "3FolksMedia",
    date: "Aug 2020 - Nov 2020",
    desc: "",
    accomplishments: [
      "Established sustaining data pipelines to analyze engagement trends, driving a 178% boost in brand visibility.",
      "Applied NLP to process 100K+ data points, extracting insights that improved customer sentiment analysis by 3x."
    ],
    skills: [
      "Data Science",
      "NLP",
      "Data Pipelines",
      "Customer Sentiment Analysis"
    ],
  },
  {
    id: 8,
    img: "https://media.istockphoto.com/id/913972086/vector/bird-icon.jpg?s=612x612&w=0&k=20&c=SVeydBGRr0MQ0l5aR2nON_xvM8LAIv2BKEHyAzCHDTI=",
    role: "Head of Software Development",
    company: "Mangala Trading",
    date: "Jun 2020 - Jul 2020",
    desc: "",
    accomplishments: [
      "Streamlined operational workflows via Python and ML models, decreasing costs by 20% and enhancing case efficiency.",
      "Orchestrated data-driven sales analysis and dashboards using SQL and visualization tools, driving 43% revenue growth."
    ],
    skills: [
      "Python",
      "Machine Learning",
      "SQL",
      "Data Visualization"
    ],
  }
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ9QlNlEqxdd1bF71qHC3c7YE7fB41gS7Pl6rlPEhc4ZrVGcssHsYm181xZVFonJ2atwv8&usqp=CAU",
    school: "Arizona State University , USA",
    date: "Aug 2024 - May 2026",
    grade: "3.9/4.0 GPA",
    degreeType: "Masters",
    coursework: ["Data Mining", "Statistics for Data Analysts", "Adv DB Management Systems", "Machine Learning"],
    desc: "Coursework: Data Mining, Statistics for Data Analysts, Adv DB Management Systems, Machine Learning.",
    degree: "Master of Science in Data Science, Analytics and Engineering",
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/en/d/dc/St._Francis_Institute_of_Technology_logo.gif",
    school: "St. Francis Institute of Technology (University of Mumbai), India",
    date: "Aug 2018 - May 2022",
    grade: "3.8/4.0 GPA",
    degreeType: "Bachelors",
    coursework: ["Data Management", "Cloud Computing", "Object-Oriented Programming", "Mathematics and Statistics"],
    desc: "Coursework: Data Management, Cloud Computing, Object-Oriented Programming, Mathematics and Statistics.",
    degree: "Bachelor of Engineering in Electronics and Telecommunication, Computer Science",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRtXd64PcxDJx8YrLhF2AFyB7Sznhl0oEW0Vw&s",
    school: "Nirmala Memorial Foundation College of Commerce and Science",
    date: "2016 - 2018",
    grade: "Grade: A+",
    degreeType: "High School",
    coursework: ["Physics", "Chemistry", "Mathematics", "Biology"],
    desc: "High School Diploma with a focus on Science stream.",
    degree: "HSC in Science",
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSNHbiMb0oJR2DVG7Lve-Gf2Tde6C15UrFP4g&s",
    school: "Children's Academy, Ashok Nagar",
    date: "2004 - 2016",
    grade: "Grade: A+",
    degreeType: "Secondary School",
    coursework: ["English", "Mathematics", "Science", "Social Studies"],
    desc: "SSC with a strong foundation in core academic subjects.",
    degree: "Secondary School Certificate (SSC)",
  }
];

export const projects = [
  {
    id: 24,
    title: "Smart Industrial Maintenance System : AI-Powered Predictive Maintenance & MILP Scheduling",
    date: "Jan 2026 – May 2026",
    description: `Built an end-to-end AI-powered industrial maintenance decision support system on two NASA datasets (C-MAPSS turbofan, IMS Bearing vibration) with 32,000+ sensor observations.

• Designed a 4-model ML suite: (1) LSTM Temporal Autoencoder for unsupervised anomaly detection (μ + 3σ reconstruction threshold); (2) LSTM Classifier with temporal attention mechanism for failure prediction (AUC-ROC: 0.983, F1: 0.851); (3) XGBoost Regressor for Remaining Useful Life estimation (R²: 0.813, RMSE: 17.82 cycles); (4) Bayesian Weibull AFT Survival model for uncertainty-quantified time-to-failure (C-Index: 0.951, 90%/95% credible intervals).
• Engineered 200+ features from raw sensor telemetry including rolling statistics, trend slopes, lag features, and pairwise sensor interactions — with temporal windowing (30-cycle sequences) and walk-forward cross-validation to prevent data leakage.
• Formulated and solved a MILP maintenance scheduling optimizer (PuLP) with crew-capacity constraints (≤3 concurrent jobs), time windows, and safety thresholds — achieving 97.6% cost reduction and 72.5% downtime reduction vs. reactive maintenance in Monte Carlo simulation (99.2% failure reduction).
• Delivered a 7-page Streamlit dashboard (Fleet Overview, Risk Assessment, Maintenance Schedule, Model Performance, Explainability via SHAP + attention heatmaps, Maintenance History, Operational Context) with 50 unit tests across 4 modules.`,
    image: "/sims-dashboard.png",
    tags: [
      "PyTorch",
      "LSTM",
      "Deep Learning",
      "XGBoost",
      "Bayesian Inference",
      "Anomaly Detection",
      "Survival Analysis",
      "Predictive Maintenance",
      "MILP Optimization",
      "Monte Carlo Simulation",
      "Streamlit",
      "SHAP",
      "Feature Engineering",
      "Python",
      "Time-Series Analysis"
    ],
    category: "Machine Learning",
    github: "https://github.com/urvanshshah/Smart-Industrial-Maintenance-System",
    webapp: "",
  },
  {
    id: 0,
    title: "Tuberculosis Burden by Country : Global Analytics Dashboard",
    date: "Aug 2025 - Dec 2025",
    description: `Designed and built a multi-view Tableau dashboard analyzing the global Tuberculosis (TB) burden across 219 countries over a 24-year span using the WHO TB dataset.

• Integrated 12 analytical visualizations covering incidence, prevalence, mortality, TB-HIV co-infection rates, case detection gaps, and regional trends : enabling country-level and longitudinal comparisons in a single interactive interface.
• Performed end-to-end data preparation including cleaning, feature renaming, missing value handling, and restructuring country-year records to support time-series analysis at scale.
• Surfaced under-reporting patterns by visualizing case detection gaps, helping identify regions with critical public-health blind spots.`,
    image: "/tb-dashboard.jpg",
    tags: [
      "Tableau",
      "Data Visualization",
      "Public Health Analytics",
      "WHO TB Dataset",
      "Data Cleaning",
      "Dashboard Design",
      "Interactive Analytics",
      "Healthcare Data",
      "Global Health",
      "Data Preprocessing",
      "Calculated Fields"
    ],
    category: "Data Analytics",
    github: "https://github.com/urvanshshah/Tuberculosis-Burden-by-Country-Global-Analytics-Dashboard",
    webapp: "",
  },
  {
    id: 1,
    title: "Real-Time Phishing Website Detection : ML + Chrome Extension",
    date: "Jan 2025 - May 2025",
    description: `Built an end-to-end real-time phishing website detection system combining machine learning, adversarial robustness testing, and a deployed Chrome browser extension.

• Trained and benchmarked 5 classifiers (Random Forest, SVM, KNN, Naive Bayes, Decision Tree) on PhishTank + Tranco List datasets; Random Forest achieved 99% accuracy and F1-score with a sub-4% false positive rate, outperforming traditional blacklist-based approaches.
• Engineered HTML-based features using BeautifulSoup extracting form fields, script tags, hidden elements, external link counts, SSL indicators, and domain attributes converting raw page content into numerical feature vectors for real-time classification.
• Deployed a Chrome browser extension with the trained Random Forest model embedded for live in-browser phishing detection, alerting users instantly with 3-option feedback UI (proceed, go back, report false positive) validated by an 87% user satisfaction rate.
• Built a public-facing Streamlit URL verification interface and a phishing simulation site for adversarial testing; implemented a continuous retraining pipeline fed by user-submitted false positives/negatives to improve model accuracy over time.
• Conducted multilingual phishing testing (Spanish, French, German) and adversarial robustness evaluation against URL obfuscation, domain spoofing, and JavaScript injection attacks.`,
    image: "/phishing-detection.jpg",
    tags: [
      "Python",
      "Machine Learning",
      "Random Forest",
      "Cybersecurity",
      "Feature Engineering",
      "Chrome Extension",
      "Streamlit",
      "Web Scraping",
      "PhishTank",
      "Real-time Detection",
      "Scikit-learn",
      "HTML Analysis",
      "SVM",
      "BeautifulSoup",
      "JavaScript",
      "Chrome Extension API",
      "Pandas",
      "matplotlib"
    ],
    category: "Machine Learning",
    github: "https://github.com/urvanshshah/Real-Time-Phishing-Website-Detection-ML-Chrome-Extension",
    webapp: "",
  },
  {
    id: 2,
    title: "Automated Warehouse Robot Planning : Answer Set Programming (ASP)",
    date: "Jan 2025 - May 2025",
    description: `Targeting multi-robot planning in an automated warehouse environment, this project was designed and implemented at Arizona State University using Answer Set Programming (ASP) with Clingo, inspired by the ASP Challenge 2019.

• Modeled a dynamic warehouse as a discrete time-step system: encoded robots, shelves, picking stations, products, and orders as ASP predicates, with inertia rules to propagate state across time steps and handle the frame problem.
• Engineered hard constraints for collision avoidance (no two robots/shelves on same node), anti-swap prevention (blocking position exchanges across consecutive steps), highway restrictions, and grid boundary enforcement across a 16×16 warehouse grid.
• Implemented full action semantics: robot movement (4-directional), shelf pickup/putdown, and order delivery with carrying-state fluents (free/carrying) and weighted cosine delivery verification logic.
• Validated across 5 warehouse instances, fulfilling 33 of 34 total orders with plan lengths ranging from 12 to 30 steps; applied #minimize optimization to reduce total robot action counts.`,
    image: "/warehouse-asp.png",
    tags: [
      "Answer Set Programming",
      "ASP",
      "Clingo",
      "Declarative Logic Programming",
      "Constraint Satisfaction",
      "Temporal Reasoning",
      "AI Planning",
      "Logic Programming",
      "Constraint Reasoning",
      "Planning Systems",
      "Declarative Modeling",
      "Robotics",
      "Automation",
      "Collision Avoidance",
      "Python"
    ],
    category: "Artificial Intelligence",
    github: "https://github.com/urvanshshah/Automated-Warehouse-Robot-Planning-Answer-Set-Programming-ASP-",
    webapp: "",
  },
  {
    id: 3,
    title: "Rideshare Demand Forecasting : Time Series & ML Model Benchmarking",
    date: "Aug 2024 - Dec 2024",
    description: `Conducted an end-to-end time series demand forecasting study on the Capital Bikeshare dataset (17,379 hourly records) benchmarking 4 models across statistical, machine learning, and deep learning paradigms as part of ASU's DSE 501 course.

• Performed comprehensive EDA across 17 features uncovering commuter peak demand at 8AM and 5–6PM on weekdays, seasonal ride variation (summer peak, spring trough), and non-linear relationships between temperature/humidity/windspeed and rental counts; validated findings via F-tests and two-sample t-tests (p-values as low as 3.97e-08).
• Engineered lag features (cnt_lag_1/2/3), extracted temporal attributes (hour, weekday, month), and implemented a temporal train-test split (year 0 → train, year 1 → test) to preserve time-series integrity across all models.
• Benchmarked 4 forecasting models: ARIMA (5,1,2), SARIMA (1,1,1)(1,1,1,24), LSTM (100 units, dropout, 24-step sequences), and XGBoost with GridSearchCV evaluated on MAE and RMSE; XGBoost outperformed all models with MAE 86.83 and RMSE 93.10, a 38% improvement over ARIMA baseline.
• XGBoost feature importance revealed lag features and hourly trends as the dominant predictors, with temperature and humidity as secondary environmental drivers informing actionable resource allocation strategies for peak vs. off-peak bike availability.`,
    image: "https://miro.medium.com/v2/resize:fit:1400/1*c_fiB-YgbnMl6nntYGBMHQ.jpeg",
    tags: [
      "Python",
      "Time Series Analysis",
      "XGBoost",
      "ARIMA",
      "SARIMA",
      "LSTM",
      "Time-Series Forecasting",
      "Hypothesis Testing",
      "Pandas",
      "NumPy",
      "Matplotlib",
      "Scikit-learn",
      "Statsmodels",
      "Keras",
      "Feature Engineering",
      "Machine Learning",
      "Data Visualization",
      "TensorFlow"
    ],
    category: "Machine Learning",
    github: "https://github.com/urvanshshah/Rideshare-Demand-Forecasting-Time-Series-ML-Model-Benchmarking",
    webapp: "",
  },
  {
    id: 4,
    title: "Drought Prediction : Enhancing Forecasting Accuracy with Ensemble ML",
    date: "Aug 2024 - Dec 2024",
    description: `Developed a machine learning-based drought severity prediction system for the continental United States at Arizona State University, using over 1 million meteorological and soil records spanning 20 years (2000–2020) from the NASA POWER Project and U.S. Drought Monitor.

• Benchmarked 4 regression models: XGBoost (GPU-accelerated), CatBoost, LightGBM, and Decision Tree on 6-level drought severity classification; XGBoost emerged as the best performer with R² of 0.828 (validation) and 0.826 (test), with consistent generalization across all models.
• Engineered temporal features (year, month, day-of-week, day-of-year) from time-series date fields and processed 30–35 meteorological + soil variables (PRECTOT, T2M, QV2M, PS, WS10M, soil moisture) to capture seasonal drought patterns at U.S. county level.
• Addressed class imbalance across 6 drought severity levels (No Drought → Exceptional Drought), applied train-validation-test temporal splits (70/15/15), and conducted hyperparameter tuning via RandomizedSearchCV with cross-validation to prevent overfitting.
• Evaluated models using R², MAE, and RMSE; produced residual analysis plots and true-vs-predicted scatter plots for each model providing interpretable diagnostics for stakeholder decision-making in water resource management.`,
    image: "https://droughtmonitor.unl.edu/data/png/current/current_usdm.png",
    tags: [
      "Python",
      "XGBoost",
      "CatBoost",
      "LightGBM",
      "scikit-learn",
      "Pandas",
      "NumPy",
      "Matplotlib",
      "GPU Acceleration",
      "Time-Series Feature Engineering",
      "NASA POWER Dataset",
      "Decision Trees",
      "Data Mining",
      "Environmental Modeling",
      "Machine Learning"
    ],
    category: "Machine Learning",
    github: "https://github.com/urvanshshah/Drought-Prediction-Enhancing-Forecasting-Accuracy-with-Ensemble-ML",
    webapp: "",
  },
  {
    id: 5,
    title: "Amazon E-Commerce Database Management System : End-to-End SQL Design",
    date: "Aug 2024 - Dec 2024",
    description: `Designed and implemented a fully normalized relational database system simulating Amazon's B2C e-commerce operations at Arizona State University.

• Architected a 9-table schema (CUSTOMER, PRODUCT, SUPPLIER, ORDERS, PAYMENT, STAFF, CUSTOMERCARE, CART, SUPPLIES) with proper normalization, primary/foreign key constraints, and a fully documented ER diagram modeling real-world e-commerce workflows including order placement, payment processing, cart management, supplier relationships, and customer support.
• Built 3 analytical views (CustomerOrderDetails, ProductAvailability, CustomerCareInteractions) for sales insights, inventory tracking, and support interaction reporting.
• Implemented advanced SQL components: an audit trigger (trg_ProductAudit) for change tracking, a stored procedure (GetCustomerOrders) for parameterized order retrieval, a scalar UDF (CalculateTotalCost) for discount-applied cost calculations, and a cursor (ProductCursor) for row-level inventory processing.
• Integrated Python with SQLite3 to programmatically execute queries and simulate database operations end-to-end, bridging database design with application-layer interaction.`,
    image: "/amazon-database-diagram.png",
    tags: [
      "Microsoft SQL Server 2017",
      "T-SQL",
      "Python",
      "SQLite3",
      "Relational Modeling",
      "ER Diagrams",
      "Stored Procedures",
      "Triggers",
      "UDFs",
      "Cursors",
      "Database Design",
      "SQL",
      "Views",
      "Data Modeling",
      "Relational Database",
      "Database Engineering"
    ],
    category: "Database Management Systems",
    github: "https://github.com/urvanshshah/Amazon-E-Commerce-Database-Management-System-End-to-End-SQL-Design",
    webapp: "",
  },
  {
    id: 6,
    title: "Prototype of V2G (Vehicle-to-grid) System",
    date: "Jul 2021 - Mar 2022",
    description:
      "Formulated seamless integration of electric vehicles with the grid, driving a 579% improvement in efficiency. Leveraged data analytics to optimize real-time energy management, processing over 10,000 data points per minute, resulting in enhanced operational performance and reduced energy waste.",
    image: "https://static1.squarespace.com/static/655ca2b0f826bb7b2b4dfe90/655ca2b0f826bb7b2b4dfef1/655ca2c5f826bb7b2b4e04a1/1721637462988/?format=1500w",
    tags: [
      "Telematics", "Python", "JavaScript", "Data analytics", "IoT", "EV"
    ],
    category: "Energy Systems",
    github: "https://github.com/urvanshshah",
  },
  {
    id: 11,
    title: "Freelancing",
    date: "Parttime",
    description:
      'Revamped brand image and engineered e-commerce platforms, improving client portfolios by 144% within 2 months. Executed blockchain projects, including NFT and cryptocurrency integrations, enhancing client platforms by 37%.',
    image:
      "https://cdn.prod.website-files.com/5ec7dad2e6f6295a9e2a23dd/6501cd1441abd1a4ab2c9aa8_624cdc2355d250b5095255f1_What-is-freelancing.jpg",
    tags: ["WordPress", "WebDev", "Tools", "Platforms", "Plugins", "NFT", "Cryptocurrency"],
    category: "Web Application",
    github: "https://github.com/urvanshshah",
  },
  {
    id: 12,
    title: "Amazon Database Prototype",
    date: "Jan 2021 - May 2021",
    description:
      'Architected to optimize e-commerce data management, ensuring robust and scalable solutions for a 10k dataset. Augmented e-commerce data management efficiency, led to a 52% increase in processing speed and accuracy.',
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSOuNbvSBKTBLPzkXcxM4CnNzAFxIY2Jl3AdA&s",
    tags: ["SQL", "DBMS", "Python"],
    category: "Database Management Systems",
    github: "https://github.com/urvanshshah/AmazonDatabasePrototype",
    webapp: "",
  },
  {
    id: 13,
    title: "Discord Bot using Python",
    date: "Dec 2021 - Jan 2022",
    description:
      "Constructed a Python 3-based solution, equipped with data analytics to automate tasks on a Discord server. Achieved a 306% surge in community engagement and a 45% reduction in manual moderation through formulations.",
    image:
      "https://miro.medium.com/v2/resize:fit:1200/1*pgOjBS0d_mc10JJG8yKGvQ.png",
    tags: [
      "Python", "Discord REST API 10",
      "Data analytics",
      "Discord.py",
      "Server hosting",
      "Bot Token",
      'Pytorch',
    ],
    category: "Bot application",
    github: "https://github.com/urvanshshah/Discord-Bot-using-Python",
    webapp: "",
    Paper: "",
    youtube: ""
  },
  {
    id: 14,
    title: "Vehicle safety system and telematics",
    date: "Jul 2021 - Mar 2022",
    description:
      "Designed a streamlined integration of electric vehicles with the grid, achieving a 579% boost in efficiency. Utilized data analytics to optimize real-time energy management by processing over 10,000 data points per minute, leading to improved operational performance and minimized energy waste.",
    image:
      "https://www.geotab.com/CMS-Media-production/Blog/NA/_2018/January/telematics/blog-what-is-telematics-hero@2x.png",
    tags: ["Telematics", "Python", "JavaScript", "Data analytics", "IoT", "EV"],
    category: "Systems Project",
    github: "https://github.com/urvanshshah",
    youtube: ""
  },
  {
    id: 15,
    title: "Currency Calculator using Python GUI",
    date: "Jun 2020 - Jul 2020",
    description:
      `Currency Calculator is a software simulation made using Python and Tkinter for GUI. The simulator converts one type of currency to another. This can be readily used to make conversions in our day-to-day life making the transaction cycle quite convenient and really quick.`,
    image:
      "https://miro.medium.com/v2/resize:fit:800/1*8j_Zth-S2uLhvEiC2KiCYQ.png",
    tags: ["Python", "Tkinter", "Pandas", "Currency API"],
    category: "Web Application",
    github: "https://github.com/urvanshshah/Currency-Calculator-using-GUI",
  },
  {
    id: 16,
    title: "IoT Enabled Home Automation and monitoring using voice commands",
    date: "May 2020 - Jun 2020",
    description:
      "IoT systems are a versatile building block of the smart home with a number of benefits. A system of various sensors such as Voltage. Temperature, Passive Infrared Sensor, and various other sensors were deployed on a prototype level. Also, the system was enabled with voice commands. The system allowed the user to control the home appliances using mobile and voice commands such as Amazon Alexa and Google Assistant. The Microcontroller used was NodeMCU ESP8266.",
    image:
      "https://www.mdpi.com/sensors/sensors-21-03784/article_deploy/html/images/sensors-21-03784-g001.png",
    tags: ["NodeMCU", "Sensors", "Flask", "Python", "IoT", "MQTT", "ESP8266"],
    category: "Web Application",
    github: "https://github.com/urvanshshah",
    youtube: "",
    paper: "",
  },


  {
    id: 17,
    title: "Automated Healthcare Assistant System",
    date: "Feb 2020 - Mar 2020",
    description:
      `Automated Healthcare Assistant System is a small prototype wherein we have implemented a hardware and software integration. The data captured by the Arduino is then forwarded to the backend website where further communication is established. The main purpose is to capture symptoms of various patients using the hardware kit for example temperature, blood pressure, etc.. such significant data gives an overview of a patient's health status. These data statistics help the doctor to analyze the symptoms of the patient and perform diagnostics based on the urgency of the symptoms.`,
    image:
      "https://www.shutterstock.com/image-vector/doctors-researchers-using-innovative-technologies-600nw-1624377460.jpg",
    tags: ["Arduino", "Tkinter", "Pandas", "Python", "Web Integration", "Sensors"],
    category: "Web Application",
    github: "https://github.com/urvanshshah/Automated-Healthcare-Assistant-System",
  },

  {
    id: 18,
    title: "Automatic Baby Cradle using minimum electricity",
    date: "Feb 2019 - Mar 2019",
    description:
      `An automatic Baby Cradle that makes use of artificial water waves with motors to help in performing the swing motion of a cradle.`,
    image:
      "https://media.geeksforgeeks.org/wp-content/uploads/Project_Body_III-1024x625.jpg",
    tags: ["Artificial Water Waves Mechanism", "Sensors", "Microcontrollers", "Low Power System Design", "Motors"],
    category: "Hardware",
    github: "https://github.com/urvanshshah/",
  },






  {
    id: 19,
    title: "MetaScraper : Serverless Website Metadata API on Azure Functions",
    date: "Oct 2021 - Dec 2021",
    description: `Built and deployed MetaScraper: a serverless website metadata extraction API powered by Azure Functions, live at fetchmetatag.azurewebsites.net/api/metascraper.

• Designed an HTTP-triggered Azure Function in Node.js that accepts any domain URL as a query parameter and returns structured Open Graph metadata (title, description, image, site name) as JSON enabling real-time social media card previews and SEO diagnostics for any website.
• Integrated the open-graph-scraper Node.js library to parse OG tags, meta tags, and structured data from live websites on demand, decoupling metadata logic from the core application via a serverless microservice pattern.
• Deployed end-to-end on Azure App Service using VS Code Azure Functions extension and Azure Cloud Shell with PowerShell demonstrating full cloud deployment lifecycle from local development to production API endpoint.
• Solves a real-world gap for custom-built websites (not on WordPress/Ghost) that need a lightweight, on-demand metadata verification tool without maintaining dedicated scraping infrastructure.`,
    image: "/metascraper.png",
    tags: [
      "Azure Functions",
      "Node.js",
      "JavaScript",
      "open-graph-scraper",
      "Azure App Service",
      "Azure PowerShell",
      "VS Code",
      "Serverless Architecture",
      "REST API"
    ],
    category: "Cloud Computing",
    github: "https://github.com/urvanshshah/metascaper",
  },
  {
    id: 20,
    title: "Book Recommendation System : Collaborative Filtering at Scale",
    date: "Aug 2025 - Dec 2025",
    description: `Targeting large-scale personalized discovery, this project built a scalable book recommendation engine at Arizona State University using User-Based Collaborative Filtering on a massive real-world dataset.

• Engineered a user-item matrix using SciPy sparse matrices (CSR format) and exported it in LIBSVM format for ML compatibility; cosine similarity was used to identify the top-10 most similar users per target user.
• Designed a batch-based similarity pipeline processing users in chunks of 1,000 to handle memory constraints at scale generating 210,000+ personalized book recommendations across the full dataset.
• Implemented a weighted similarity scoring model to estimate ratings for unseen books, filtering already-rated titles and invalid ISBNs to ensure recommendation quality.
• Conducted end-to-end data preparation including deduplication, sparse matrix construction, and structured CSV output with user ID, book title, and recommendation scores.`,
    image: "/book-recommendation.png",
    tags: [
      "Python",
      "Pandas",
      "NumPy",
      "SciPy",
      "scikit-learn",
      "Collaborative Filtering",
      "Sparse Matrices",
      "LIBSVM",
      "Recommender Systems"
    ],
    category: "Machine Learning",
    github: "https://github.com/urvanshshah/Book-Recommendation-System-Collaborative-Filtering-at-Scale",
  },
  {
    id: 21,
    title: "Phoenix Neighborhood Change Analysis : Geospatial Dashboard (2000–2010)",
    date: "Aug 2025 - Dec 2025",
    description: `Exploring urban dynamics in Maricopa County, this project built an end-to-end geospatial analysis and interactive Shiny/flexdashboard at Arizona State University using longitudinal census tract data.

• Engineered a full R-based data pipeline: loaded U.S. Census tract boundaries via the tigris API, merged with LTDB socioeconomic data across 200+ variables, standardized GEOIDs, and filtered valid tracts producing a clean spatial dataset for downstream analysis.
• Generated a Dorling cartogram (population-weighted bubble map) using the cartogram package, projected to WGS84 and exported as GeoJSON enabling proportional spatial representation of census tracts by population size.
• Built a multi-tab interactive Flexdashboard with Leaflet maps, Plotly charts, and DT tables covering: neighborhood cluster analysis (MClust), median home value change, population shifts, demographic breakdowns (race, education, poverty), and tract-level popups.
• Applied Gaussian mixture model clustering (MClust) to segment Phoenix neighborhoods into distinct types based on demographics, housing, and socioeconomic indicators surfacing spatial patterns of inequality and gentrification.`,
    image: "/phoenix-geospatial.png",
    tags: [
      "R",
      "Leaflet",
      "Shiny",
      "Flexdashboard",
      "Plotly",
      "MClust",
      "cartogram",
      "tigris",
      "sf",
      "GeoJSON",
      "Geospatial Analysis"
    ],
    category: "Data Visualization",
    github: "https://github.com/urvanshshah/Phoenix-Neighborhood-Change-Analysis-Geospatial-Dashboard-2000-2010-",
  },
  {
    id: 22,
    title: "Chemical Data Analyzer : Automated EDA & Email Reporting Agent",
    date: "Jun 2025 - Jun 2025",
    description: `Targeting zero-effort laboratory workflows, this project built a fully automated chemical experiment data analysis system that handles everything from raw Excel ingestion to final emailed reports.

• Engineered an end-to-end Python pipeline that ingests chemical experiment data, computes comprehensive summary statistics (mean, std, min/max, percentiles), and auto-generates pairing line plots and single-variable histograms using Pandas, Matplotlib, and Seaborn.
• Automated report delivery via yagmail SMTP integration, attaching the statistical summary and all generated plots directly to an email sent to a configurable recipient, eliminating manual analytical labor.
• Designed with environment-variable-based configuration (.env) for secure credential management, ensuring the tool is both portable and safe for production-ready laboratory data management.`,
    image: "/chemical-analyzer.png",
    tags: [
      "Python",
      "Pandas",
      "Matplotlib",
      "Seaborn",
      "yagmail",
      "openpyxl",
      "Automation",
      "SMTP",
      "EDA"
    ],
    category: "Automation",
    github: "https://github.com/urvanshshah/github-night-hack",
  },
  {
    id: 23,
    title: "ThreatScan : Real-Time Weapon Detection System Using Computer Vision",
    date: "Mar 2025 - May 2025",
    description: `Developed ThreatScan, a high-performance weapon detection system that achieved Runner-up at the VoxelAI Computer Vision Hackathon.

• Built an end-to-end detection pipeline using YOLOv8 and PyTorch, achieving a competitive 0.85 mAP; curated a 5,000+ frame dataset with targeted augmentation to minimize false positives in high-density public environments.
• Optimized model inference by 73% through TensorRT quantization, slashing latency from 45ms to 12ms for seamless 60 FPS edge-device deployment, enabling instantaneous threat response in critical security scenarios.`,
    image: "/threatscan.png",
    tags: [
      "YOLOv8",
      "PyTorch",
      "TensorRT",
      "Computer Vision",
      "Deep Learning",
      "Edge AI",
      "Python",
      "Hackathon Runner-up"
    ],
    category: "Computer Vision",
    github: "https://github.com/urvanshshah/visual-ai-hack",
  },
];

// LinkedIn Featured Posts
export const linkedinFeatured = [
  {
    id: 0,
    title: "Honored to be a Mentor at sunhacks 2025!",
    description: "Excited to mentor aspiring developers and data scientists at Arizona State University's premier hackathon. Sharing knowledge and helping teams build innovative solutions.",
    image: "/linkedin-sunhacks.png",
    link: "https://www.linkedin.com/posts/urvansh-shah_sunhacks2025-asu-hackathon-activity-7378600260765573120-XFYI?utm_source=share&utm_medium=member_desktop",
    date: "Sep 2025",
    likes: 142,
    comments: 32,
    type: "achievement"
  },
  {
    id: 1,
    title: "Honored to be nominated for July's award at Sila Nanotechnologies",
    description: "Grateful for the recognition of my contributions to battery technology research and data science initiatives at Sila Nanotechnologies.",
    image: "/linkedin-sila.jpg",
    link: "https://www.linkedin.com/posts/urvansh-shah_datascience-internship-recognition-activity-7357988756613750784-qbEy?utm_source=share&utm_medium=member_desktop",
    date: "Aug 2025",
    likes: 198,
    comments: 54,
    type: "achievement"
  },
  {
    id: 2,
    title: "GitHub AI Hack Night in San Francisco!",
    description: "Amazing experience at GitHub's AI Hack Night, collaborating with talented developers and exploring cutting-edge AI technologies.",
    image: "/linkedin-github.png",
    link: "https://www.linkedin.com/posts/urvansh-shah_github-ai-innovation-activity-7352124812749602816-4W7f?utm_source=share&utm_medium=member_desktop",
    date: "Jul 2025",
    likes: 168,
    comments: 24,
    type: "post"
  }
];






export const TimeLineData = [
  { year: 2018, text: "Started B.E. in Electronics & Telecommunication at SFIT" },
  { year: 2020, text: "Data Scientist at 3FolksMedia" },
  { year: 2021, text: "Software Developer Intern at Microsoft" },
  { year: 2022, text: "Senior Analyst at Dentsu & Co-Founded Mahaveer Technologies" },
  { year: 2024, text: "Started M.S. in Data Science at Arizona State University" },
  { year: 2025, text: "Data Science Intern at Sila Nanotechnologies & Research Assistant Technical Staff at ASU SciHub" },
  { year: 2026, text: "Completed M.S. in Data Science at Arizona State University" },
];

// Freelancing Projects
export const freelancingProjects = [
  {
    id: 0,
    title: "E-Commerce Development",
    description: "Built responsive e-commerce platforms with payment integration, inventory management, and admin dashboards for multiple clients",
    technologies: ["WordPress", "React", "Node.js", "Stripe", "MongoDB"],
    image: "https://cdn.prod.website-files.com/5ec7dad2e6f6295a9e2a23dd/6501cd1441abd1a4ab2c9aa8_624cdc2355d250b5095255f1_What-is-freelancing.jpg",
    category: "Web Development",
    clientsServed: 5
  },
  {
    id: 1,
    title: "NFT & Blockchain Projects",
    description: "Developed NFT marketplaces and cryptocurrency integration solutions with smart contract implementation",
    technologies: ["Solidity", "Web3.js", "React", "Ethereum", "IPFS"],
    image: "https://image-cdn.hypb.st/https%3A%2F%2Fhypebeast.com%2Fimage%2F2021%2F10%2Fbored-ape-yacht-club-nft-3-4-million-record-sothebys-metaverse-0.jpg?w=960&cbr=1&q=90&fit=max",
    category: "Blockchain",
    clientsServed: 3
  },
  {
    id: 2,
    title: "WordPress Solutions",
    description: "Custom WordPress themes, plugins, and full website development with SEO optimization and performance tuning",
    technologies: ["WordPress", "PHP", "MySQL", "JavaScript", "CSS"],
    image: "https://i.ytimg.com/vi/-nonf361t5c/maxresdefault.jpg",
    category: "CMS Development",
    clientsServed: 8
  },
  {
    id: 3,
    title: "Discord Bot Development",
    description: "Created custom Discord bots with automation, moderation, and community management features using Python and Discord.py",
    technologies: ["Python", "Discord.py", "MongoDB", "REST API"],
    image: "https://cdn.mos.cms.futurecdn.net/my8AUCgUhKERqBBwdPQuXG-1200-80.jpg",
    category: "Bot Development",
    clientsServed: 4
  }
];

// Certifications
export const certifications = [
  {
    id: 0,
    title: "Using Python for Automation",
    issuer: "LinkedIn Learning",
    date: "2024",
    skills: ["Python", "Automation", "Scripting"],
    link: "https://www.linkedin.com/learning/certificates/e7ff66d455a390fe2f5195954efd2eaa281a374da8f2d6cb0120ce802a110652",
    platform: "linkedin"
  },
  {
    id: 1,
    title: "Marketing in a Digital World",
    issuer: "Coursera",
    date: "2023",
    skills: ["Digital Marketing", "SEO", "Social Media"],
    link: "https://www.coursera.org/account/accomplishments/certificate/G5QQFQWEW4V8",
    platform: "coursera"
  },
  {
    id: 2,
    title: "Python",
    issuer: "HackerRank",
    date: "2024",
    skills: ["Python", "Problem Solving", "Algorithms"],
    link: "https://www.hackerrank.com/certificates/701438b3dd0a",
    platform: "hackerrank"
  },
  {
    id: 3,
    title: "Python Data Structures",
    issuer: "University of Michigan",
    date: "2023",
    skills: ["Python", "Data Structures", "Algorithms"],
    link: "https://www.coursera.org/account/accomplishments/certificate/FZKMEA36ZUTM",
    platform: "coursera"
  },
  {
    id: 4,
    title: "Create Your First Python Program",
    issuer: "Coursera",
    date: "2023",
    skills: ["Python", "Programming Basics"],
    link: "https://www.coursera.org/account/accomplishments/certificate/JCFHSRN29WVB",
    platform: "coursera"
  },
  {
    id: 5,
    title: "Programming for Everybody",
    issuer: "University of Michigan",
    date: "2023",
    skills: ["Python", "Programming Fundamentals"],
    link: "https://www.coursera.org/account/accomplishments/certificate/U97MF6RESJN5",
    platform: "coursera"
  },
  {
    id: 6,
    title: "PyCode: Python Programming",
    issuer: "SFIT",
    date: "2022",
    skills: ["Python", "Competitive Programming"],
    link: "https://drive.google.com/file/d/1Ikf0xh6_C-S9P4cpCfug5EvLMrgN03G4/view",
    platform: "other"
  },
  {
    id: 7,
    title: "Use WordPress to Create a Blog for your Business",
    issuer: "Rhyme",
    date: "2023",
    skills: ["WordPress", "Blogging", "CMS"],
    link: "https://www.coursera.org/account/accomplishments/verify/ZSX66LL4TPJB",
    platform: "coursera"
  },
  {
    id: 8,
    title: "Build a Full Website using WordPress",
    issuer: "Coursera",
    date: "2023",
    skills: ["WordPress", "Web Development", "CMS"],
    link: "https://www.coursera.org/account/accomplishments/certificate/HJ2U7X2U6USD",
    platform: "coursera"
  }
];



// LinkedIn Recommendations (placeholder data — replace with real ones)
export const linkedinRecommendations = [
  {
    id: 0,
    name: "Dr. Deepak J. Jayaswal",
    title: "Principal",
    company: "SFIT",
    color: "#0077B5",
    avatar: "/avatar-male.png",
    relation: "Deepak was Urvansh's teacher",
    date: "March 14, 2026",
    text: "I highly recommend this student for his sincerity and strong work ethic. He is hardworking, responsible, and consistently dedicated to their tasks. In addition to their academic commitment, they are socially well-connected and maintain positive relationships with peers. They are always willing to help others and contribute positively to the group environment. Their supportive nature and responsible attitude make them a valuable member of any academic or professional setting.",
    linkedinUrl: "https://www.linkedin.com/in/urvansh-shah",
  },
  {
    id: 1,
    name: "Smit Supeda",
    title: "Team Lead",
    company: "Dentsu (Merkle)",
    color: "#E91E8C",
    avatar: "/avatar-male.png",
    relation: "Smit managed Urvansh directly",
    date: "February 19, 2026",
    text: "I had the pleasure of working with Urvansh at Merkle, where he consistently stood out for his analytical thinking, professionalism, and strong sense of ownership. He approaches complex business challenges with structure and clarity, delivering thoughtful insights that create meaningful impact. Urvansh is dependable, detail oriented, and highly adaptable in fast paced environments. He collaborates effectively across teams and communicates ideas with confidence and precision. Beyond his technical strength, he demonstrates maturity, initiative, and a continuous drive to improve. Any organization seeking a high performing, growth oriented professional would benefit from having Urvansh on their team.",
    linkedinUrl: "https://www.linkedin.com/in/urvansh-shah",
  },
  {
    id: 2,
    name: "Dr. Kevin Prathap Noronha",
    title: "HOD",
    company: "SFIT",
    color: "#854CE6",
    avatar: "/avatar-male.png",
    relation: "Kevin was Urvansh's teacher",
    date: "2026",
    text: "I have known Urvansh Shah since 2018 as his professor and had the opportunity to closely observe his academic and technical growth. He is a highly diligent and analytical individual with a strong grasp of concepts and excellent problem-solving abilities. Urvansh demonstrated his skills through projects like an Amazon Database Prototype using AWS and an energy-efficient automated system, showcasing both innovation and technical depth. His proficiency in programming, curiosity to learn, and leadership in team settings make him a standout performer. I strongly endorse his capabilities and potential for impactful contributions.",
    linkedinUrl: "https://www.linkedin.com/in/urvansh-shah",
  },
  {
    id: 3,
    name: "Martin Reisslein",
    title: "Program Chair",
    company: "Arizona State University",
    color: "#00BFA5",
    avatar: "/avatar-male.png",
    relation: "Martin was Urvansh's mentor",
    date: "2025",
    text: "I had the opportunity to supervise Urvansh Shah as a Graduate Student Assistant and Lead Lab Grader at Arizona State University. He consistently demonstrated strong analytical thinking, technical expertise, and a genuine commitment to student success. Urvansh efficiently evaluated assignments and projects for a large class while providing clear, constructive feedback that helped students improve their problem-solving and programming skills. Beyond grading, he actively mentored students, simplifying complex concepts and guiding them effectively. His attention to detail, organizational skills, and leadership in supporting both students and faculty make him a highly reliable and impactful contributor.",
    linkedinUrl: "https://www.linkedin.com/in/urvansh-shah",
  },
];

// Letter of Recommendations (placeholder data — replace with real ones)
export const letterRecommendations = [
  {
    id: 0,
    from: "Anand Kamath",
    fromTitle: "Team Lead",
    fromOrg: "Dentsu (Merkle)",
    date: "Anand managed Urvansh directly",
    subject: "Letter of Recommendation — Urvansh Shah",
    preview: "I am pleased to recommend Mr. Urvansh Shah, who worked under my supervision at Merkle company, for over a year. During this time, he consistently demonstrated strong analytical abilities, dedication, and professionalism. He effectively handled tasks such as analyzing global survey data, collaborating with international teams, and deriving actionable insights. Urvansh also led a high-visibility project, utilizing Python, JavaScript, and data tools to deliver impactful results, earning client appreciation and internal recognition, including the RNR award. His adaptability, leadership, and commitment make him an excellent candidate for graduate studies. I strongly support his application.",
    fullText: `To Whom It May Concern,

I am pleased to recommend Mr. Urvansh Shah, who worked under my supervision at Merkle, for over a year. During this time, he consistently demonstrated strong analytical abilities, dedication, and professionalism.

He effectively handled tasks such as analyzing global survey data, collaborating with international teams, and deriving actionable insights. Urvansh also led a high-visibility project, utilizing Python, JavaScript, and data tools to deliver impactful results, earning client appreciation and internal recognition, including the RNR award.

His adaptability, leadership, and commitment make him an excellent candidate for graduate studies. I strongly support his application.

Sincerely,
Anand Kamath
Team Lead
Merkle`,
    avatar: "/avatar-male.png",
    color: "#854CE6",
  },
  {
    id: 1,
    from: "Rajesh P. Sheth",
    fromTitle: "CEO",
    fromOrg: "MTC",
    date: "Rajesh was Urvansh's mentor",
    subject: "Letter of Recommendation — Urvansh Shah",
    preview: "During his time at MTC, Urvansh Shah demonstrated a strong ability to adapt quickly and contribute effectively across multiple domains, including marketing, technical operations, sales, and management. He consistently showed a proactive mindset, taking ownership of tasks and approaching challenges with a solution-oriented attitude.",
    fullText: `To Whom It May Concern,

During his time at MTC, Urvansh Shah demonstrated a strong ability to adapt quickly and contribute effectively across multiple domains, including marketing, technical operations, sales, and management. He consistently showed a proactive mindset, taking ownership of tasks and approaching challenges with a solution-oriented attitude. His ability to understand both technical and business aspects allowed him to add meaningful value to the team. Urvansh's enthusiasm, work ethic, and versatility made him a dependable contributor, and I am confident in his ability to excel in dynamic, cross-functional environments.

Sincerely,
Rajesh P. Sheth
CEO
MTC`,
    avatar: "/avatar-male.png",
    color: "#E67E22",
  },
];

// Achievements
export const achievements = [
  {
    id: 0,
    title: "Research with Nobel Laureate Prof. Frank Wilczek",
    description: "Working with Nobel Laureate Prof. Frank Wilczek on research initiatives at the ASU SciHub Center, building data pipelines, ML models, and embedded hardware systems.",
    icon: "",
    date: "Nov 2025 - Present",
    organization: "ASU SciHub Center",
    category: "research",
    link: "https://www.linkedin.com/in/urvansh-shah/"
  },
  {
    id: 1,
    title: "LinkedIn Top Voice 2024",
    description: "Recognized as a LinkedIn Top Voice for sharing insights on data science, AI, and technology with a growing professional community.",
    icon: "",
    date: "2024",
    organization: "LinkedIn",
    category: "recognition",
    link: "https://www.linkedin.com/in/urvansh-shah/"
  },
  {
    id: 2,
    title: "Three-Time National Hackathon Winner",
    description: "Won three national-level hackathons and competitions, including IDEATHON and IDEATE, showcasing skills in project innovation, strategic planning, and problem-solving.",
    icon: "",
    date: "2023",
    organization: "National Competitions",
    category: "competition",
    link: "https://www.linkedin.com/in/urvansh-shah/"
  },
  {
    id: 3,
    title: "Rewards and Recognition by Dentsu",
    description: "Recognized for exceptional performance at Dentsu with 4 Gold Medals, 3 RNR awards, and 1 annual trophy for outstanding client achievements.",
    icon: "",
    date: "2022-2024",
    organization: "Dentsu",
    category: "work",
    link: "https://www.linkedin.com/in/urvansh-shah/"
  },
  {
    id: 4,
    title: "Mentor & Judge, SunHacks 2025",
    description: "Served as a Mentor and Judge at SunHacks 2025, Arizona State University's premier hackathon, guiding teams in building innovative solutions.",
    icon: "",
    date: "2025",
    organization: "SunHacks, Arizona State University",
    category: "leadership",
    link: "https://www.linkedin.com/posts/urvansh-shah_sunhacks2025-asu-hackathon-activity-7378600260765573120-XFYI?utm_source=share&utm_medium=member_desktop"
  },
  {
    id: 5,
    title: "Invited Speaker & Panelist",
    description: "Invited speaker and panelist at GitHub AI Hack Night, Glimpse, and Arizona State University career events, sharing experiences in data science, AI, and career growth.",
    icon: "",
    date: "2025",
    organization: "GitHub, Glimpse & ASU",
    category: "leadership",
    link: "https://www.linkedin.com/posts/urvansh-shah_github-ai-innovation-activity-7352124812749602816-4W7f?utm_source=share&utm_medium=member_desktop"
  },
  {
    id: 6,
    title: "Head of NSS-SFIT",
    description: "Headed the National Service Scheme (NSS) unit at St. Francis Institute of Technology, leading 350+ members in community service and social initiatives.",
    icon: "",
    date: "2019-2021",
    organization: "NSS, SFIT",
    category: "leadership",
    link: "https://www.linkedin.com/in/urvansh-shah/"
  },
  {
    id: 7,
    title: "VoxelAI Computer Vision Hackathon Runner-up",
    description: "Secured Runner-up with ThreatScan, a real-time weapon detection system built with YOLOv8 and TensorRT, achieving 0.85 mAP and 12ms inference latency.",
    icon: "",
    date: "2025",
    organization: "VoxelAI",
    category: "competition",
    link: "https://github.com/urvanshshah/visual-ai-hack"
  },
  {
    id: 8,
    title: "Top Performance in Data Science",
    description: "Achieved high distinction with a 3.9/4.0 GPA in the Master's program in Data Science, Analytics and Engineering at Arizona State University.",
    icon: "",
    date: "2024-2026",
    organization: "Arizona State University",
    category: "academic",
    link: "https://www.linkedin.com/in/urvansh-shah/"
  }
];
